var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voc-editor"},[_c('div',{ref:"ref-toolbar",staticClass:"toolbar-container",attrs:{"id":"voc-editor-toolbar"}}),_c('div',{ref:"ref-editor",staticClass:"editor-container",attrs:{"id":"voc-editor-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }